import jQuery from "jquery";
import "@lottiefiles/dotlottie-wc";
import "waypoints/lib/noframework.waypoints";

jQuery(($) => {
    // Handle uploaded MP4 video play button
    $('.js-video').each(function () {
        const $component = $(this)
        const $videoWrapper = $component.find('.js-video__video')
        const videoSource = $videoWrapper.data('source')

        if (videoSource !== 'upload') return

        const $video = $videoWrapper.find('.js-video__html5')
        if (!$video.length) return

        const videoEl = $video[0]
        const $playButton = $component.find('.js-video__play-button')

        // Parent's video.js binds a click handler that assumes an iframe-based
        // embed and throws a TypeError on upload videos. Unbind it here for
        // this specific upload video's button and replace with our HTML5 handler.
        $playButton.off('click')

        $playButton.on('click', function () {
            $(this).fadeOut()
            videoEl.play()
        })

        // Autoplay via waypoint
        if ($component.hasClass('has-autoplay')) {
            videoEl.muted = true

            new Waypoint({
                element: $component[0],
                handler: function () {
                    $component.find('.js-video__play-button').fadeOut()
                    videoEl.play()
                },
                offset: 'bottom-in-view',
            })
        }
    })
});
